// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //rootBase : 'http://localhost:8082',
  //rootRest : 'http://localhost:8081',
  rootBase : 'https://www.cloudkitchenkoraput.in',
  rootRest : 'https://www.cloudkitchenkoraput.in',
  cdnHost : 'https://www.cloudkitchenkoraput.in/cdn/',
  //rootBase : 'http://www.cloudkitchenkoraput.in',
  //rootRest : 'http://www.cloudkitchenkoraput.in',
  //cdnHost : 'http://www.cloudkitchenkoraput.in/cdn/',
  key: "AIzaSyCz3C0aykWWCbAC4nQO5-uvdF8UWcFk4iQ"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
